var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.8901C20.5738 17.3946 19.5788 18.7203 18.3119 19.7514C17.045 20.7825 15.5448 21.4875 13.9424 21.8049C12.3401 22.1222 10.6844 22.0422 9.12015 21.5719C7.55587 21.1015 6.13062 20.2551 4.96902 19.1067C3.80741 17.9583 2.94481 16.5428 2.45663 14.984C1.96845 13.4252 1.86956 11.7706 2.1686 10.1647C2.46763 8.55886 3.15549 7.05071 4.17204 5.77211C5.18859 4.49351 6.50288 3.4834 8 2.83008",
    stroke: "#FAFCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V12H22Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.ffd1872e008882d865fe4eb43e5b9b8f.svg";
export { ForwardRef as ReactComponent };